
import React from 'react';
import { Button } from '@/components/ui/button';

interface RevenueSplitActionsProps {
  setIsAdding: React.Dispatch<React.SetStateAction<boolean>>;
  handleAddNew: () => void;
}

const RevenueSplitActions: React.FC<RevenueSplitActionsProps> = ({
  setIsAdding,
  handleAddNew
}) => {
  return (
    <div className="flex justify-end space-x-2">
      <Button variant="outline" onClick={() => setIsAdding(false)}>Cancel</Button>
      <Button onClick={handleAddNew}>Add Split Tier</Button>
    </div>
  );
};

export default RevenueSplitActions;
